/* Listicle page (sections/lst-offer): purchase-option picker, add to cart via
   the theme cart drawer (pdp-trimmer.js globals openCart / CartState /
   insertPendingLine), sticky CTA visibility and smooth in-page jumps. */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* smooth jumps for #anchors (CTA → buy box, link → ingredient list) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-lst-jump]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var t = document.getElementById(href.slice(1));
    if (!t) return;
    e.preventDefault();
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', href);
  });

  function sync(form) {
    var on = form.querySelector('.lst-opt input:checked');
    if (!on) return;
    var plan = form.querySelector('[data-lst-plan-input]');
    if (plan) {
      plan.value = on.value;
      plan.disabled = !on.value;
    }
    var price = on.getAttribute('data-price'), day = on.getAttribute('data-day');
    $$('[data-lst-price]').forEach(function (el) { el.textContent = price; });
    $$('[data-lst-day]').forEach(function (el) { el.textContent = day; });
  }

  function priceCents(str) {
    var n = parseFloat(String(str || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function initForm(form) {
    if (form.__lst) return;
    form.__lst = true;
    form.addEventListener('change', function (e) {
      if (e.target.matches('.lst-opt input')) sync(form);
    });
    sync(form);

    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('[data-lst-add]');
      var err = form.querySelector('[data-lst-err]');
      var hasDrawer = document.getElementById('mm-cart') && typeof window.openCart === 'function';
      if (!hasDrawer || !window.fetch) return; /* native POST to /cart/add */
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      if (err) { err.hidden = true; err.textContent = ''; }
      var label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = 'Adding…';

      var id = form.querySelector('input[name="id"]').value;
      var on = form.querySelector('.lst-opt input:checked');
      var pending = null;
      if (typeof window.insertPendingLine === 'function') {
        pending = { id: id, title: form.getAttribute('data-title') || document.title, image: form.getAttribute('data-image') || '', price: priceCents(on ? on.getAttribute('data-price') : form.getAttribute('data-price')) };
        try { window.insertPendingLine(pending); window.openCart(); } catch (x) { pending = null; }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res.json().catch(function () { return {}; }).then(function (j) {
            throw new Error(j.description || j.message || 'Could not add to cart. Please try again.');
          });
        })
        .then(function () {
          try { window.openCart(); } catch (x) {}
          if (window.CartState && typeof window.CartState.fetch === 'function') return window.CartState.fetch();
        })
        .catch(function (x) {
          if (pending) {
            try { if (typeof window.removePendingLine === 'function') window.removePendingLine(pending.id); } catch (y) {}
            try { if (typeof window.closeCart === 'function') window.closeCart(); } catch (y) {}
            if (window.CartState && typeof window.CartState.fetch === 'function') window.CartState.fetch();
          }
          if (err) { err.textContent = (x && x.message) || 'A network error occurred. Please try again.'; err.hidden = false; }
        })
        .then(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  /* sticky CTA: visible once the hero CTA has scrolled above the viewport, hidden
     while the buy box is on screen. Measured on scroll (rAF-throttled) rather than
     with IntersectionObserver, which misses jumps that skip past an element. */
  function initSticky() {
    var bar = document.querySelector('[data-lst-sticky]');
    if (!bar || bar.__lst) return;
    bar.__lst = true;
    var hero = document.querySelector('[data-lst-hero] .lst-cta') || document.querySelector('[data-lst-hero]');
    var buy = document.querySelector('[data-lst-buy]');
    var queued = false;
    function paint() {
      queued = false;
      var vh = window.innerHeight;
      var heroGone = !hero || hero.getBoundingClientRect().bottom < 0;
      var buyIn = false;
      if (buy) { var r = buy.getBoundingClientRect(); buyIn = r.top < vh * 0.9 && r.bottom > 0; }
      bar.hidden = !(heroGone && !buyIn);
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  }

  /* sticky contents rail: mark the reason currently under the top of the viewport */
  function initToc() {
    var links = $$('[data-lst-toc-link]');
    if (!links.length || links[0].__lst) return;
    links[0].__lst = true;
    var reasons = links.map(function (a) { return document.getElementById('reason-' + a.getAttribute('data-lst-toc-link')); });
    var queued = false;
    function paint() {
      queued = false;
      var active = -1;
      reasons.forEach(function (el, i) { if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.35) active = i; });
      links.forEach(function (a, i) {
        a.classList.toggle('is-active', i === active);
        if (i === active) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  }

  function init() {
    initToc();
    $$('[data-lst-form]').forEach(initForm);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
